import React from 'react'
import cn from 'classnames'
import { withTranslation } from 'react-i18next'

import UserAvatarWithStats from 'app/components/UserAvatarWithStats/UserAvatarWithStats'
import FeedStoriesListItemMenu from './FeedStoriesListItemMenu'
import { getUserInitials, getUserFullName } from 'helpers/getUserUIData'
import FeedStory from '../../FeedStory'
import FeedReactions from '../../FeedReactions'

import './styles.scss'
import TagIcon from 'app/components/SVGS/TagIcon'
export const bc = 'feed-stories-list-item'

export const FeedStoriesListItem = ({
  t,
  identity,
  user,
  activityUserStory,
  setReaction,
  reactions,
  updateReaction,
  showReactions,
  loadStoryActivity,
  handleSetFeedStoryLikeOld,
  index,
  isNewEvent,
}) => {
  const identityData = identity.toJS()
  const userData = user || identityData
  const { firstName, lastName, avatar, email } = userData
  const initials = getUserInitials(firstName, lastName, email)
  const fullName = getUserFullName(firstName, lastName)
  const userReaction = reactions && reactions.find(item => item.user.id === identityData.id)
  const { id, activity, story, activityId, mentions } = activityUserStory
  const isMentioned = mentions && mentions.length > 0 && mentions.find(item => item.user.id === identityData.id)
  const isIdentityStory = identityData.id === user.id
  return (
    <div className={cn(bc, { [`${bc}__new`]: isNewEvent })} onAnimationEnd={() => handleSetFeedStoryLikeOld(index)}>
      {isMentioned && (
        <div className={`${bc}__mention-message`}>
          <TagIcon />
          <div className={`${bc}__mention-text`}>{t('You were tagged')}</div>
        </div>
      )}
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__image`}>
          <UserAvatarWithStats
            isRecentFeed
            avatar={avatar}
            initials={initials}
            circleProps={{
              cx: 20,
              cy: 20,
              strokeWidth: 2,
              r: 19,
            }}
          />
        </div>
        <div className={`${bc}__user`}>
          <div className={`${bc}__title`}>
            <div className={`${bc}__user-name`}>{fullName}</div>
            {isIdentityStory && <FeedStoriesListItemMenu storyId={id} question={activity.question} story={story} />}
          </div>
          <FeedStory story={story} activity={activity} onLoadStoryActivity={() => loadStoryActivity(id, activityId)} />
        </div>
      </div>
      {showReactions && (
        <div className={`${bc}__reactions`}>
          <FeedReactions
            reactions={reactions}
            hasReacted={Boolean(userReaction)}
            setReaction={emoji => {
              userReaction ? updateReaction(userReaction, emoji) : setReaction(emoji, id, identityData)
            }}
            likeActionEnabled={user.id !== identityData.id}
          />
        </div>
      )}
    </div>
  )
}

export default withTranslation('user')(FeedStoriesListItem)
